export interface ProposalBriefDraft {
  proposalNameSuggestion: string;
  projectSummary: string;
  deliverables: string;
  assumptions: string;
  exclusions: string;
  recommendedSections: string;
}

export function toMultiline(values: string[]) {
  return values.join('\n');
}

export function fromMultiline(value: string) {
  return value
    .split('\n')
    .map((item) => item.trim())
    .filter(Boolean);
}

export function toBriefDraft(brief: ProposalBrief): ProposalBriefDraft {
  return {
    proposalNameSuggestion: brief.proposalNameSuggestion,
    projectSummary: brief.projectSummary,
    deliverables: toMultiline(brief.deliverables),
    assumptions: toMultiline(brief.assumptions),
    exclusions: toMultiline(brief.exclusions),
    recommendedSections: toMultiline(brief.recommendedSections),
  };
}

export function toProposalBrief(draft: ProposalBriefDraft): ProposalBrief {
  return {
    proposalNameSuggestion: draft.proposalNameSuggestion.trim(),
    projectSummary: draft.projectSummary.trim(),
    deliverables: fromMultiline(draft.deliverables),
    assumptions: fromMultiline(draft.assumptions),
    exclusions: fromMultiline(draft.exclusions),
    recommendedSections: fromMultiline(draft.recommendedSections),
  };
}
